import JwtService from "@/core/services/JwtService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { useToast } from "vue-toastification";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { GET_SELECTED_SITES_STR, SITE_STORE } from "@/store/userSite/types";

export const interceptRequest = (requestConfig: AxiosRequestConfig) => {
  const token = JwtService.getToken();
  if (token) {
    requestConfig.headers.Authorization = `bearer ${token}`;
    const key = `${SITE_STORE}/${GET_SELECTED_SITES_STR}`;
    if (
      !requestConfig.url?.includes("header=false") &&
      store.getters[key] &&
      store.getters[key].length > 0
    ) {
      requestConfig.headers.siteIds = store.getters[key] ?? null;
    }
  }

  return requestConfig;
};

export const interceptRequestError = (error: any) => {
  return Promise.reject(error);
};

export const interceptResponse = (response: AxiosResponse) => {
  return response;
};

export const interceptResponseError = (error: any) => {
  const res = error.response;
  if (res.status >= 500) {
    // silence toast notifications for specifc request statuses.
    if (!res.config.headers["x-silent-status"]?.includes(res.status)) {
      // Alert users when there's a server side API error.
      if (res.config.url.startsWith("site/sites")) {
        useToast().error(res.data.debugMessage);
      } else {
        useToast().error(res.data.message || res.data.error || "Server Error");
      }
    }
  }
  if (res.status === 401) {
    store.dispatch(Actions.LOGOUT);
    window.location.href = "#/sign-in";
  } else if (res.status >= 400 && res.status < 500) {
    // silence toast notifications for specifc request statuses.
    if (!res.config.headers["x-silent-status"]?.includes(res.status)) {
      // Alert users when there's a 400x API error.
      useToast().error(res.data.message || res.data.error || "Unknown Error");
    }
  }
  return Promise.reject(error);
};
